'use client';

import { useContext } from 'react';
import PropTypes from 'prop-types';
import useSWR from 'swr';

import TextBlock from '../TextBlock/TextBlock';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import DataErrorItem from '../DataErrorItem/DataErrorItem';

import { fetchFenixEditorialContent } from '../../clients/fenixClient';
import { CountryContext } from '../../utils/country-provider';
import { t } from '../../i18n';

const fetcher = ([isoCode, contentType]) =>
    fetchFenixEditorialContent(isoCode, contentType);

const FenixTextValue = ({ title = '', editorialContentType = 'OVERVIEW' }) => {
    const countryMeta = useContext(CountryContext);

    const swrKey = countryMeta?.code
        ? [countryMeta.code, editorialContentType]
        : null;

    const { data, error, isLoading } = useSWR(swrKey, fetcher);

    if (isLoading) return <SkeletonLoader />;
    if (error || (data && !data.ok)) {
        return <DataErrorItem description={t('general.errorFetchingData')} />;
    }
    if (!data?.html) return null;

    return (
        <TextBlock
            title={title}
            content={data.html}
            updatedAt={data.publishedAt || ''}
        />
    );
};

FenixTextValue.propTypes = {
    title: PropTypes.string,
    editorialContentType: PropTypes.oneOf([
        'OVERVIEW',
        'HISTORY',
        'ECONOMY',
        'POLITICS',
        'HOLDINGS',
    ]),
};

export default FenixTextValue;
